module.exports = __webpack_public_path__ + "img/menu-icon-lines.8a8333c0.svg";